import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmSaleRoDetailModel } from "../vrmBillSaleRoModel";
import { Description } from "@/components/YhBox/Description";
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailLookForm, getVrmTreeNodeName
    } = useVrmSaleRoDetailModel();

    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>

    const orderStatu: IDescription[] = [
        {
            label: "销售退货单",
            value: detailLookForm?.returnCode as string ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: (detailLookForm?.status && getVrmTreeNodeName(detailLookForm?.status as string)) ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}